import { Helmet } from 'react-helmet-async';
import { SITE } from '../content/site.js';

/**
 * Per-route meta. Note that WhatsApp, Facebook and LinkedIn crawlers do not
 * execute JavaScript, so these tags are only visible to them once the route
 * is prerendered at build time — index.html carries the defaults meanwhile.
 */
export default function Seo({ title, description, path = '/', noindex = false }) {
  const fullTitle = title ? `${title} · ${SITE.name}` : `${SITE.name} · ${SITE.tagline}`;
  const desc = description ?? SITE.description;
  const url = `${SITE.domain}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
}
